import axios from 'axios'

const signin = async (login, password) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/signin`, { login, password })
  return data
}

const signon = async (
  login,
  name,
  phone,
  cpf,
  password,
  password2
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/signon`, {
    login,
    name,
    phone,
    cpf,
    password,
    password2
  })
  return data
}

const validateEmail = async (key) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/validate-email`, {
    key
  })
  return data
}

const facebookSignin = async (accessToken, id) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/facebook/signin`, { accessToken, id })
  return data
}

const facebookSignon = async (accessToken, id, login, phone, name, picture) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/facebook/signon`, { accessToken, id, login, phone, name, picture })
  return data
}

const forgotPass = async (login, check = false) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/forgot-pass`, { login, check })
  return data
}

const codeRemove = async (nameRemove, emailRemove, phoneRemove, subject) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/code-remove`, { nameRemove, emailRemove, phoneRemove, subject })
  return data
}

const forgotPassChange = async (login, code, password, password2, name, phone) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/forgot-pass/change`, { login, code, password, password2, name, phone })
  return data
}

// Facebook login (WEB & CORDOVA)
const facebook = () => new Promise((resolve, reject) => {
  // Cordova
  if (process.env.CORDOVA_PLATFORM) {
    if (!window.facebookConnectPlugin) reject(new Error('Facebook could not start'))
    window.facebookConnectPlugin.login(
      ['public_profile', 'email'],
      response => {
        if (response.status === 'connected') {
          const accessToken = response.authResponse.accessToken
          window.facebookConnectPlugin.api(
            '/me?fields=id,name,email,picture', ['public_profile', 'email'],
            response => resolve({
              accessToken,
              id: response.id,
              email: response.email,
              name: response.name,
              picture: response.picture
            }),
            error => reject(new Error(error))
          )
        }
      },
      error => reject(new Error(error))
    )
  // Web
  } else {
    if (!window.FB) reject(new Error('Facebook could not start'))
    window.FB.login(response => {
      if (response.status === 'connected') {
        const accessToken = response.authResponse.accessToken
        window.FB.api('/me', { fields: 'id, name, email, picture' },
          response => resolve({
            accessToken,
            id: response.id,
            email: response.email,
            name: response.name,
            picture: response.picture
          })
        )
      } else {
        reject(new Error(response))
      }
    }, { scope: 'public_profile, email' })
  }
})

const savePlayerId = async (playerId) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/player-id`, { playerId })
  return data
}

const apple = async () => {
  // Cordova
  if (process.env.CORDOVA_PLATFORM) {
    return new Promise((resolve, reject) => {
      window.cordova.plugins.SignInWithApple.signin(
        { requestedScopes: [0, 1] },
        (success) => resolve({
          token: success.identityToken,
          email: success.email || null,
          name: success.fullName ? success.fullName.givenName + ' ' + success.fullName.familyName : null
        }),
        (error) => reject(error)
      )
    })
  // Web
  } else {
    const data = await window.AppleID.auth.signIn()
    return {
      token: data.authorization.id_token,
      email: data.user ? data.user.email : null,
      name: data.user ? data.user.name.firstName + ' ' + data.user.lastName : null
    }
  }
}

const appleSignin = async (idToken) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/apple/signin`, { idToken })
  return data
}

const appleSignon = async (idToken, login, phone, name) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/auth/apple/signon`, { idToken, login, phone, name })
  return data
}

const removeData = async () => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/auth/remove-data`)
  return data
}

export {
  signin,
  signon,
  validateEmail,
  facebookSignin,
  facebookSignon,
  facebook,
  forgotPass,
  codeRemove,
  forgotPassChange,
  savePlayerId,
  apple,
  appleSignin,
  appleSignon,
  removeData
}
